import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Tabs } from "antd";
import Breadcrumb from "../../components/Breadcrumb";
import FUBSettings from "./FUBSettings";
import BuyerPool from "./BuyerPool";

const FUBIntegration = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab from URL
  const activeTab = location.pathname.includes("/buyer-pool")
    ? "buyer-pool"
    : "settings";

  const handleTabChange = (key) => {
    navigate(`/company/${companyId}/integrations/fub/${key}`);
  };

  const items = [
    {
      key: "settings",
      label: "Settings",
      children: <FUBSettings embedded />,
    },
    {
      key: "buyer-pool",
      label: "Buyer Pool",
      children: <BuyerPool embedded />,
    },
  ];

  return (
    <div className="m-4">
      <Breadcrumb
        title="Follow Up Boss"
        items={[
          { title: "Dashboard", href: `/company/${companyId}/dashboard` },
          {
            title: "Integrations",
            href: `/company/${companyId}/integrations`,
          },
          { title: "Follow Up Boss" },
        ]}
      />
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={items}
        className="mt-4"
      />
    </div>
  );
};

export default FUBIntegration;
